import { o as o_util } from "../chunks/common-namespaces-client-C7k75bsz.mjs";
const toggle = o_util.toggle ?? {};
const get = toggle.get;
const getToggle = toggle.getToggle;
export {
  get,
  getToggle,
  toggle
};
/*                                      */
